import baseRoutes from './base.routes'
import appReturnRoutes from './appReturn.routes'
import appSplashRoutes from './appSplash.routes'
import accountRoutes from './account.routes'
import authRoutes from './auth.routes'
import contentfulRoutes from './contentful.routes'
import partnerRoutes from './partner.routes'
import retailerRoutes from './retailer.routes'
import testsRoutes from './tests.routes'

const firebaseAuthRoute = {
  path: '__/auth/action',
  name: 'FirebaseAuthAction',
  component: () => import('src/pages/shared/auth/FirebaseAuthPage.vue'),
}

const firebaseAuthCallbackRoute = {
  path: '__/auth/callback',
  name: 'FirebaseAuthCallback',
  component: () => import('src/pages/shared/auth/FirebaseAuthCallbackPage.vue'),
}

export default [
  // Maintenance Page Route - minimal layout with no header/footer
  {
    path: '/maintenance',
    component: () => import('src/layouts/shared/MinimalLayout.vue'),
    children: [
      {
        path: '',
        name: 'MaintenancePage',
        component: () => import('src/pages/shared/MaintenancePage.vue'),
        meta: {
          skipMaintenanceCheck: true, // Prevent infinite redirect
        },
      },
    ],
  },

  // Delivery Verification — public, token-authenticated (PEG-545)
  {
    path: '/delivery-verification',
    component: () => import('src/layouts/shared/MinimalLayout.vue'),
    children: [
      {
        path: '',
        name: 'DeliveryVerification',
        component: () => import('src/pages/public/DeliveryVerificationPage.vue'),
      },
    ],
  },

  // Error Page Route - minimal layout with no header/footer
  {
    path: '/error',
    component: () => import('src/layouts/shared/MinimalLayout.vue'),
    children: [
      {
        path: '',
        name: 'ErrorPage',
        component: () => import('src/pages/shared/ErrorPage.vue'),
      },
    ],
  },

  // PEG-509: Admin session expired / invalid / reused / logout — minimal layout
  {
    path: '/admin/expired',
    component: () => import('src/layouts/shared/MinimalLayout.vue'),
    children: [
      {
        path: '',
        name: 'AdminExpired',
        component: () => import('src/pages/shared/admin/AdminExpiredPage.vue'),
      },
    ],
  },

  // Standard Shopping (Shared)
  {
    path: '/',
    alias: ['/app'],
    component: () => import('src/layouts/shared/ShoppingLayout.vue'),
    children: [
      baseRoutes,
      accountRoutes,
      authRoutes,
      firebaseAuthRoute,
      firebaseAuthCallbackRoute,
      retailerRoutes,
      contentfulRoutes,
    ],
  },

  // Tests Routes (DEV only)
  ...testsRoutes,

  // Partner Routes
  // Example: /p/partner-name/*
  partnerRoutes,
  // Return Flow (App Only)
  // Example: /app/return/*
  appReturnRoutes,
  // Splash Page (App Only)
  // Example: /app/splash/
  appSplashRoutes,

  // Forget Me — redirects to in-app account deletion (Google Play Data Safety URL)
  {
    path: '/help/forget-me',
    redirect: { name: 'AccountDelete' },
  },

  // APP CATCHALL
  // This route is used to catch all app routes that are not defined above
  {
    path: '/app/:slug1/:slug2?/:slug3?/:slug4?',
    component: () => import('layouts/shared/ShoppingLayout.vue'),
    children: [
      {
        path: '',
        name: 'AppCatchall',
        component: () => import('src/pages/shared/ContentfulDynamicPage.vue'),
      },
    ],
  },

  // WEB CATCHALL
  // This route is used for the web app to catch all dynamic pages
  {
    path: '/:slug1/:slug2?/:slug3?/:slug4?',
    component: () => import('src/layouts/shared/ShoppingLayout.vue'),
    children: [
      {
        path: '',
        name: 'WebCatchall',
        component: () => import('src/pages/shared/ContentfulDynamicPage.vue'),
      },
    ],
  },
]
